import { feature_activation_keys } from "features/FeatureActivation/FeatureActivationStatus.constants";
import useFeaturesActivationStatus from "features/FeatureActivation/utils/useFeaturesActivationStatus";

const useOfferingAutoDebitEnabled = () => {
  const { loading, featuresActivationStatus } = useFeaturesActivationStatus();
  const isOfferingAutoDebitEnabled =
    featuresActivationStatus[feature_activation_keys.is_auto_debit_enabled.key];
  return { loading, isOfferingAutoDebitEnabled };
};

export default useOfferingAutoDebitEnabled;
